<template>
    <!-- <div class="contenedor_contenido"> -->

    <!-- <div class="cabecera_contenido">

            <div class="btn_menu_contextual" @click="abrir_modal_crear_articulo">
                Crear árticulo
            </div>

            <div class="btn_menu_contextual">
                Reportes
            </div>

        </div> -->
    <!-- <div class="contenido_"> -->
    <b-container fluid="">
        <b-row>
            <div class="col-sm-2 mt-3">
                <select class="form-control form-control-sm" v-model="tipo_busqueda"
                    @change="limpiar_registros_de_busqueda">
                    <option value="">Seleccionar</option>
                    <option value="codigo">Código</option>
                    <option value="nombre">Nombre</option>
                </select>
            </div>

            <div class="col-sm-2 mt-3">
                <!-- <input type="search" placeholder="Buscar" class="form-control form-control-sm"> -->
                <select class="form-control form-control-sm" v-model="seleccion_sucursal"
                    @change="limpiar_registros_de_busqueda">
                    <option value="">Seleccionar sucursal</option>
                    <option value="todas">TODAS</option>
                    <option v-for="(item, index) in sucursales" :key="index" :value="item.codigo">{{ item.nombre }}
                    </option>
                </select>
            </div>

            <div class="col-sm-6 mt-3">
                <!-- <input type="search" placeholder="Buscar" class="form-control form-control-sm"> -->
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text"><i class="fas fa-search"></i></span>
                    </div>
                    <input type="text" id="campo_busqueda_inventario" autocomplete="off"
                        class="form-control form-control-sm" list="articulos_" v-model="campo_busqueda"
                        placeholder="Buscar" aria-label="Buscar" aria-describedby="basic-addon1"
                        @keydown.enter="buscar_articulos">
                    <!-- <datalist id="articulos_">
                        <option v-for="(item, index) in lista_productos" :key="index" :value="item.codigo">{{
                            item.nombre
                        }}</option>
                    </datalist> -->
                </div>
            </div>

            <div class="col-sm-2 mt-3">
                <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                    @click="buscar_articulos">Buscar</button>
            </div>
            <div class="col-sm-12 mt-2">
                <div class="marco-tabla-lista-articulos">
                    <table class="table table-sm table-striped table-bordered" style="font-size: 11px;">
                        <thead>
                            <tr>
                                <th style="width: 10%;text-align: center;">
                                    Código
                                </th>
                                <th style="width: 65%;">
                                    Descripción
                                </th>
                                <th style="width: 15%;">
                                    Sucursal
                                </th>
                                <th style="width: 10%;text-align: center;">
                                    ...
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in registros" :key="index" @dblclick="abrir_modal_ficha_producto">
                                <td style="text-align: center;font-size: 13px;">
                                    {{ item.codigo }}
                                </td>
                                <td style="font-size: 13px;">
                                    {{ item.nombre }}
                                </td>
                                <td style="font-size: 13px;text-align: center;">
                                    {{ item.nombre_sucursal }}
                                </td>
                                <td v-if="!item.formula" style="text-align: center;">
                                    <button type="button" style="font-size: 11px;margin-right: 5px;"
                                        class="btn btn-sm btn-outline-dark" @click="abrir_modal_vista_previa(item)"><i
                                            class="fas fa-shopping-cart"></i></button>
                                    <button type="button" style="font-size: 11px;" class="btn btn-sm btn-outline-dark"
                                        @click="abrir_modal_ficha_producto(item)"><i class="fas fa-eye"></i></button>
                                </td>
                                <td v-else style="text-align: center;">
                                    <button type="button" style="font-size: 11px;" class="btn btn-sm btn-outline-dark"
                                        @click="abrir_modal_ficha_producto(item)"><i class="fas fa-eye"></i></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>


            </div>

        </b-row>

        <VistaPrevia v-if="modal_vista_previa" :item_previa="item_previa" v-on:salir="cerrar_modal_vista_previa" />
        <FichaProducto v-if="modal_ficha_producto" v-on:salir="cerrar_modal_ficha_producto"
            v-on:reset_precios="buscar_articulos" />

        <FichaFormula v-if="modal_ficha_formula" v-on:salir="cerrar_modal_ficha_formula" :item="item" />
        <CrearArticulo v-if="modal_crear_articulo" :modulo_del_que_viene="'inventario_busqueda'"
            v-on:salir="cerrar_modal_crear_articulo" />

        <div v-if="permisos['inventarios.busqueda.crear_articulo']?.ver || ES_ROOT" class="btn_crear_agregar"
            @click="abrir_modal_crear_articulo">
            <i class="fas fa-plus"></i>
        </div>

    </b-container>
</template>

<script>

import VistaPrevia from './VistaPrevia.vue'
import FichaProducto from './FichaProducto.vue'
import CrearArticulo from '../Articulo/CrearArticulo.vue'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import FichaFormula from './FichaFormula.vue'
import { minix } from '@/components/functions/alertas'

export default {
    name: 'Busqueda',
    components: {
        VistaPrevia,
        FichaProducto,
        CrearArticulo,
        FichaFormula
    },
    computed: {
        ...mapState(['sucursales', 'id_empresa_seleccionada', 'permisos', 'datos_usuario']),
        ...mapGetters(['ES_ROOT', 'FILTRAR_PRODUCTOS_POR_SUCURSAL'])
    },
    data() {
        return {
            modal_vista_previa: false,
            modal_ficha_producto: false,
            modal_ficha_formula: false,
            modal_crear_articulo: false,
            item: {},
            item_previa: {},
            campo_busqueda: '',
            tipo_busqueda: 'codigo',
            registros: [],
            seleccion_sucursal: 'todas'
        }
    },
    methods: {
        abrir_modal_vista_previa(item) {
            this.item_previa = item
            this.modal_vista_previa = true
        },
        cerrar_modal_vista_previa() {
            this.modal_vista_previa = false
        },
        abrir_modal_ficha_producto(item) {
            if (item.formula == true) {
                // this.item = item
                this.set_objeto_busqueda(item)
                this.modal_ficha_formula = true
            } else {
                // this.item = item
                this.set_objeto_busqueda(item)
                this.modal_ficha_producto = true
            }
        },
        cerrar_modal_ficha_producto() {
            this.modal_ficha_producto = false
        },
        abrir_modal_crear_articulo() {
            this.modal_crear_articulo = true
        },
        cerrar_modal_crear_articulo() {
            this.modal_crear_articulo = false
        },
        cerrar_modal_ficha_formula() {
            this.modal_ficha_formula = false
        },
        async buscar_articulos() {

            if (this.campo_busqueda != '') {
                let f = {
                    api: `articulos/c/busqueda_por_codigo?tipo_busqueda=${this.tipo_busqueda}&campo_busqueda=${this.campo_busqueda}&sucursal=${this.seleccion_sucursal}&empresa=${this.id_empresa_seleccionada}`
                }

                let r = await this.obtener_data(f)

                if (r.length == 0) {
                    minix({ icon: 'warning', mensaje: 'No se encontraron registros', tiempo: 2000 })
                    document.getElementById('campo_busqueda_inventario').select()
                } else {
                    this.registros = r
                }


            } else {
                minix({ icon: 'error', mensaje: 'Ingrese el codigo o el nombre del producto', tiempo: 2000 })
                document.getElementById('campo_busqueda_inventario').focus()
            }

        },
        limpiar_registros_de_busqueda() {
            this.registros = []
        },
        ...mapActions(['obtener_data']),
        ...mapMutations(['set_objeto_busqueda'])
    },
}
</script>

<style>

.marco-tabla-lista-articulos {
    width: 100%;
    height: calc(100vh - 140px);
    overflow: auto; 
}

.marco-tabla-lista-articulos thead th {
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 10;
}

</style>
